import { Component, CUSTOM_ELEMENTS_SCHEMA, inject, OnInit } from '@angular/core'
import { MatButtonModule } from '@angular/material/button'
import { MatIconModule } from '@angular/material/icon'
import { CommonModule, Location } from '@angular/common'
import { Store } from '@ngrx/store'
import { getClient, getSelectOrder, OrderHistory } from '@monorepo-channels/channels/domain'
import { combineLatest, map, take } from 'rxjs'
import { MatBottomSheet } from '@angular/material/bottom-sheet'
import { DataLayerService, isMobile, MenuOpened, OptimizeImage } from '@monorepo-channels/shared/util-helpers'
import { Router, RouterOutlet } from '@angular/router'
import { MatDialog } from '@angular/material/dialog'
import { SwiperUiComponent } from '@monorepo-channels/components/ui-porto-bank'
import { CancelOrderComponent } from '../../dialog/cancel-order.component'

@Component({
	selector: 'feature-porto-bank-order-details',
	standalone: true,
	imports: [CommonModule, MatIconModule, MatButtonModule, RouterOutlet, OptimizeImage, SwiperUiComponent],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
	templateUrl: './order-details.component.html',
	styleUrls: ['./order-details.component.scss'],
})
export class OrderDetailsComponent implements OnInit {
	private store = inject(Store)
	public location = inject(Location)
	public router = inject(Router)
	private selectedOrder$ = this.store.select(getSelectOrder)
	private client$ = this.store.select(getClient)
	public bottomSheet = inject(MatBottomSheet)
	public dialog = inject(MatDialog)
	public menuOpened = inject(MenuOpened)
	isMobile = isMobile()
	private dataLayerService = inject(DataLayerService)

	public vm$ = combineLatest([this.selectedOrder$, this.client$]).pipe(
		map(([order, client]) => ({ order, client }))
	)

	ngOnInit(): void {
		this.selectedOrder$.pipe(take(1)).subscribe(order => {
			this.dataLayerService.logEvent({
				event: 'screen_view',
				screen_name: 'Gastronomia Porto Bank - Detalhes do Pedido',
				orderId: order?.id,
			})
			if (!order) {
				this.goBack()
			}
		})
	}

	openMenu(url: string) {
		window.open(`${url}`, '_self')
	}

	goBack() {
		this.router.navigate(['/reservas-e-checkins'])
	}

	cancelOrder(order: OrderHistory | null) {
		if (!order) return

		this.dialog.open(CancelOrderComponent, {
			data: order,
			width: '400px',
		})
	}
}
